/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { createEntity } from 'jotai/entity';
import { WorkspaceObject } from '.';
import { defaultRace } from './defaultWorkspaces/DefaultRace';
import { SystemWorkspaceId } from './SystemWorkspaceId';
import { defaultQualifying } from './defaultWorkspaces/DefaultQualifying';
import { defaultPractice } from './defaultWorkspaces/DefaultPractice';
import { defaultTest } from './defaultWorkspaces/DefaultTest';
import { mobileView } from './defaultWorkspaces/MobileView';
import { mobileViewIndy } from './defaultWorkspaces/indy/MobileViewIndy';
import { blankIndyWorkspace } from './defaultWorkspaces/indy/BlankIndy';
import { blankNascarWorkspace } from './defaultWorkspaces/BlankNascar';
import { defaultRaceIndy } from './defaultWorkspaces/indy/DefaultRaceIndy';

export const systemWorkspaces: Record<SystemWorkspaceId, WorkspaceObject> = {
  [SystemWorkspaceId.Blank]: {
    id: SystemWorkspaceId.Blank,
    name: 'Blank',
    slug: 'blank',
    owner: 'system',
    activeView: 't1',
    views: {
      byId: {
        t1: { id: 't1', name: 'Primary View', visualizations: [], layouts: 'vl1' },
      },
      allIds: ['t1'],
    },
    viewLayouts: {
      byId: {
        vl1: [],
      },
      allIds: ['vl1'],
    },
    visualizations: {
      byId: {},
      allIds: [],
    },
    visualizationSettings: {
      byId: {},
      allIds: [],
    },
    selectedCompetitorGroups: {},
    competitorGroups: createEntity(),
    competitorGroupVehicles: createEntity(),
    selectedReferenceVehicle: createEntity(),
    hideFooter: false,
    trackMapSettings: createEntity(),
  },
  [SystemWorkspaceId.DefaultPractice]: defaultPractice,
  [SystemWorkspaceId.DefaultQualifying]: defaultQualifying,
  [SystemWorkspaceId.DefaultRace]: defaultRace,
  [SystemWorkspaceId.DefaultRaceIndy]: defaultRaceIndy,
  [SystemWorkspaceId.DefaultTest]: defaultTest,
  [SystemWorkspaceId.MobileView]: mobileView,
  [SystemWorkspaceId.MobileViewIndy]: mobileViewIndy,
  [SystemWorkspaceId.BlankNascar]: blankNascarWorkspace,
  [SystemWorkspaceId.BlankIndy]: blankIndyWorkspace,
};
